export default __webpack_public_path__ + "static/media/pdf.c688352f.webp";